import React from "react";
import { Outlet } from "react-router-dom";
import BottomNav from "@/components/BottomNav";

export default function CustomerLayout() {
  return (
    <div className="mobile-frame pb-24" data-testid="customer-layout">
      <div className="page-enter">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
